'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DataTypes = require('../../data_types').default;
var Sqlite_DATE = /** @class */ (function (_super) {
    __extends(Sqlite_DATE, _super);
    function Sqlite_DATE(precision, timezone) {
        var _this = _super.call(this, precision, timezone) || this;
        _this.dataType = 'datetime';
        return _this;
    }
    Sqlite_DATE.prototype.uncast = function (value) {
        try {
            return _super.prototype.uncast.call(this, value);
        }
        catch (error) {
            console.error(new Error("unable to cast ".concat(value, " to DATE")));
            return value;
        }
    };
    return Sqlite_DATE;
}(DataTypes.DATE));
var Sqlite_DATEONLY = /** @class */ (function (_super) {
    __extends(Sqlite_DATEONLY, _super);
    function Sqlite_DATEONLY() {
        return _super.call(this) || this;
    }
    Sqlite_DATEONLY.prototype.uncast = function (value) {
        try {
            return _super.prototype.uncast.call(this, value);
        }
        catch (error) {
            console.error(new Error("unable to cast ".concat(value, " to DATEONLY")));
            return value;
        }
    };
    return Sqlite_DATEONLY;
}(DataTypes.DATEONLY));
var Sqlite_INTEGER = /** @class */ (function (_super) {
    __extends(Sqlite_INTEGER, _super);
    function Sqlite_INTEGER(dataLength, unsigned, zerofill) {
        return _super.call(this, dataLength, unsigned, zerofill) || this;
    }
    Sqlite_INTEGER.prototype.uncast = function (value) {
        return _super.prototype.uncast.call(this, value, false);
    };
    return Sqlite_INTEGER;
}(DataTypes.INTEGER));
var Sqlite_BIGINT = /** @class */ (function (_super) {
    __extends(Sqlite_BIGINT, _super);
    function Sqlite_BIGINT(dataLength, unsigned, zerofill) {
        var _this = _super.call(this, dataLength, unsigned, zerofill) || this;
        _this.dataType = 'integer';
        return _this;
    }
    Sqlite_BIGINT.prototype.toSqlString = function () {
        return this.dataType.toUpperCase();
    };
    return Sqlite_BIGINT;
}(DataTypes.BIGINT));
var Sqlite_BINARY = /** @class */ (function (_super) {
    __extends(Sqlite_BINARY, _super);
    function Sqlite_BINARY(dataLength) {
        if (dataLength === void 0) { dataLength = 255; }
        var _this = _super.call(this, dataLength) || this;
        _this.dataLength = dataLength;
        _this.dataType = 'binary';
        return _this;
    }
    Sqlite_BINARY.prototype.toSqlString = function () {
        var dataLength = this.dataLength;
        var dataType = this.dataType.toUpperCase();
        var chunks = [];
        chunks.push('VARCHAR');
        chunks.push(dataLength > 0 ? "".concat(dataType, "(").concat(dataLength, ")") : dataType);
        return chunks.join(' ');
    };
    return Sqlite_BINARY;
}(DataTypes.BINARY));
var Sqlite_VARBINARY = /** @class */ (function (_super) {
    __extends(Sqlite_VARBINARY, _super);
    function Sqlite_VARBINARY(dataLength) {
        var _this = _super.call(this, dataLength) || this;
        _this.dataType = 'varbinary';
        return _this;
    }
    return Sqlite_VARBINARY;
}(Sqlite_BINARY));
var Sqlite_DataTypes = /** @class */ (function (_super) {
    __extends(Sqlite_DataTypes, _super);
    function Sqlite_DataTypes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Sqlite_DataTypes, "DATE", {
        get: function () {
            return Sqlite_DATE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sqlite_DataTypes, "BIGINT", {
        get: function () {
            return Sqlite_BIGINT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sqlite_DataTypes, "BINARY", {
        get: function () {
            return Sqlite_BINARY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sqlite_DataTypes, "VARBINARY", {
        get: function () {
            return Sqlite_VARBINARY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sqlite_DataTypes, "DATEONLY", {
        get: function () {
            return Sqlite_DATEONLY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sqlite_DataTypes, "INTEGER", {
        get: function () {
            return Sqlite_INTEGER;
        },
        enumerable: false,
        configurable: true
    });
    return Sqlite_DataTypes;
}(DataTypes));
module.exports = Sqlite_DataTypes;
//# sourceMappingURL=data_types.js.map